import GoogleRecaptcha from './google-recaptcha-container';

export default GoogleRecaptcha;
